import { render, staticRenderFns } from "./ViewTag.vue?vue&type=template&id=282c7fc0&"
import script from "./ViewTag.vue?vue&type=script&lang=js&"
export * from "./ViewTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports